/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import {
  ICreateCommentPayload,
  ICreatePostPayload,
  IDeletePostPayload,
  IGetCommentsPayload,
  IGetNotificationsPayload,
  IGetPostByIdPayload,
  IGetPostsPayload,
  IGetRepliesPayload,
  IReactToPostPayload,
} from "../models/social.model";

export const getPosts = async (payload: IGetPostsPayload) => {
  const res = await axios.get("/sn-post", {
    params: {
      page: payload.page,
      limit: payload.limit,
      hashtags: payload.hashtag?.join(","),
      content: payload.content,
      country: payload.countryCode,
      userId: payload.userId,
    },
  });
  return res;
};

export const getPostById = async (payload: IGetPostByIdPayload) => {
  const res = await axios.get(`/sn-post/${payload.postId}`);
  return res;
};

export const createPost = async (payload: FormData) => {
  const res = await axios.post("/sn-post", payload);
  return res;
};

export const getComments = async (payload: IGetCommentsPayload) => {
  const res = await axios.get(`/post/${payload.postId}/comment`, {
    params: {
      page: payload.page,
      limit: payload.limit,
    },
  });
  return res;
};

export const createComment = async (payload: ICreateCommentPayload) => {
  const res = await axios.post(`/comment`, payload);
  return res;
};

export const getReplies = async (payload: IGetRepliesPayload) => {
  const res = await axios.get(`/comment/${payload.commentId}/replies`, {
    params: {
      page: payload.page,
      limit: payload.limit,
    },
  });
  return res;
};

export const reactToPost = async (payload: IReactToPostPayload) => {
  const res = await axios.post(`/reaction`, payload);
  return res;
};

export const getPostStats = async () => {
  const res = await axios.get("/stats");
  return res;
};

export const getNotifications = async (payload: IGetNotificationsPayload) => {
  const res = await axios.get("/notification", {
    params: {
      page: payload.page,
      limit: payload.limit,
    },
  });
  return res;
};

export const deletePost = async (payload: IDeletePostPayload) => {
  const res = await axios.delete(`/sn-post/${payload.postId}`);
  return res;
};
